<template>
  <div class="bg-login">
    <div class="login-header container title">

    </div>
    <div class="main">
      <div class="title">
        <div class="title-content">
          <el-image style="width: 150px; height: 61px" src="../../static/Logo_WG.png" fit="scale-down"></el-image>
          <div style="font-size:30px;border-bottom: 2px solid white;margin-bottom:5px;color:lightblue;padding-bottom:5px;">游戏联运商户数据管理系统</div>
          <div style="font-size:18px;padding-bottom:5px;">1. SDK接入</div>
          <div style="font-size:18px;padding-bottom:5px;">2. 计费管理</div>
          <div style="font-size:18px;padding-bottom:5px;">3. 订单查询</div>
          <div style="font-size:18px;padding-bottom:5px;">4. 数据统计</div>
        </div>
        <div>
          <div class="middle-box loginscreen bg-white">
              <div class="login-top"></div>
              <div class="container">
                <div class="login-title text-center" style="display:flex;align-items:center;justify-content:center;position:relative;">
                    <p style="color:block;font-size:20px;">商户入口</p>
                    <el-button v-if="showSMSVerify || showPhoneRegister || showChangePassword" type="text" class="title-back-btn" @click="goBackToLogin">
                      <i class="el-icon-arrow-left"></i> 返回
                    </el-button>
                </div>

                <!-- 验证方式选择 -->
                <!-- 商户不需要二选一，直接进入SMS认证，注释保留后期可能恢复
                <div v-if="showVerifySelect" class="verify-select">
                  <h2 class="verify-select-title">选择验证方式</h2>
                  <div class="verify-select-buttons">
                    <el-button class="verify-option-btn" @click="selectSMS">
                      <i class="el-icon-message verify-option-icon"></i>
                      <span class="verify-option-text">SMS 短信认证</span>
                    </el-button>
                    <el-button class="verify-option-btn resetMgL0" @click="selectOTP">
                      <i class="el-icon-key verify-option-icon"></i>
                      <span class="verify-option-text">Authenticator OTP 认证</span>
                    </el-button>
                  </div>
                </div>
                -->

                <!-- SMS 短信验证码 -->
                <sms-verify
                  v-if="showSMSVerify"
                  ref="smsVerifyRef"
                  :phone="smsPhone"
                  :user-info="userInfo"
                  sms-send-code-url="coupon-merch/mfa/sms/sendCodeByPhone"
                  sms-verify-code-url="coupon-merch/mfa/sms/verifyCodeByPhone"
                  :auto-send="smsAutoSend"
                  @verify-success="handleSmsVerifySuccess"
                />

                <!-- 手机号注册 -->
                <phone-register
                  v-if="showPhoneRegister"
                  :user-info="userInfo"
                  sms-send-code-url="coupon-merch/mfa/sms/sendCodeByPhone"
                  sms-verify-code-url="coupon-merch/mfa/sms/verifyCodeByPhone"
                  upd-phone-url="coupon-merch/merch/updPhone"
                  mode="merchant"
                  @register-success="handlePhoneRegisterSuccess"
                />

                <!-- 修改密码 -->
                <change-password
                  v-if="showChangePassword"
                  :user-info="userInfo"
                  upd-password-url="coupon-merch/merch/updPassword"
                  @change-success="handleChangePasswordSuccess"
                />

                <!-- OTP 设置组件（新用户）- 商户暂不使用，注释保留
                <otp-setup
                  v-if="showOtpSetup"
                  :user-info="userInfo"
                  get-mfa-secret-url="coupon-merch/merch/otp/getMfaSecret"
                  @next-step="handleOtpSetupNext" />
                -->

                <!-- OTP 验证组件（老用户）- 商户暂不使用，注释保留
                <otp-verify
                  v-if="showOTPVerify"
                  ref="otpVerifyRef"
                  :email="loginForm.lbh"
                  :token-obj="userInfo"
                  type="login"
                  otp-verify-url="coupon-merch/merch/otp/verify"
                  @verify-success="handleOtpVerifySuccess"
                  @go-to-setup="handleGoToSetup" />
                -->

                <!-- 登录表单 -->
                <el-form v-if="!showSMSVerify && !showPhoneRegister && !showChangePassword" :model="loginForm" :rules="loginRules" ref="loginForm" @submit.native.prevent>
                    <el-form-item prop="lbh">
                        <el-input v-model="loginForm.lbh" placeholder="请输入用户名/手机号" v-focus auto-complete="on"></el-input>
                    </el-form-item>

                    <el-form-item prop="lpassword">
                        <el-input type="password" v-model="loginForm.lpassword" placeholder="请输入密码" auto-complete="on"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button class="bt-width" type="primary" @click="submitForm('loginForm')">登录</el-button>
                    </el-form-item>

                </el-form>
              </div>
          </div>
          <div class="middle-box loginscreen bg-white" style="margin-top:10px">
            <div style="padding:0px;margin:2px">
              <p style="color:red;font-size:20px;padding:0px;margin:2px">重要通知[SDK更新]：</p>
              <p style="padding:0px;margin:0px">目前SDK版本已更新至<span style="color:red;">v1.9.1</span>，新版本涉及重要更新，请广大合作伙伴配合游戏计划及时更新。</p>
              <p style="padding:0px;margin:0px">SDK更新资料包，请在对接群里@工作人员获取</p>
            </div>
            <div style="border-top:1px solid #999;padding:0px;margin:2px">
              <p style="color:red;font-size:20px;padding:0px;margin:2px">合作通知：</p>
              <p style="padding:0px;margin:0px">为了保证顺利上线&正常结算，烦请还未签署合同的合作伙伴，尽快联系【对接商务BD】先行签署合同。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../js/utils.js'
import OtpVerify from '../components/verifyOTP.vue'
import OtpSetup from '../components/otpSetup.vue'
import SmsVerify from '../components/smsVerify.vue'
import PhoneRegister from '../components/phoneRegister.vue'
import ChangePassword from '../components/changePassword.vue'
export default {
  name: "login",
  components: {
    OtpVerify,
    OtpSetup,
    SmsVerify,
    PhoneRegister,
    ChangePassword
  },
  data() {
    return {
      loginForm: {
        lbh: '',
        lpassword: '',
       },
       loginRules: {
        lbh: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "blur"
            }
        ],
        lpassword: [
           {
             required: true,
             message: '请输入密码',
             trigger: 'blur'
           }
        ]
      },
      loading:false,
      // showVerifySelect: false, // 商户不需要二选一，注释保留
      showSMSVerify: false,
      showPhoneRegister: false,
      showChangePassword: false,
      // showOtpSetup: false, // 商户暂不使用OTP，注释保留
      // showOTPVerify: false, // 商户暂不使用OTP，注释保留
      userInfo: null,
      smsPhone: '',
      smsAutoSend: false
    }
  },
  created () {
    document.onkeydown = (e) => {
      if (window.event === undefined) {
        var key = e.keyCode
      } else {
        // eslint-disable-next-line no-redeclare
        var key = window.event.keyCode
      }
      if (key === 13) {
        this.submitForm('loginForm');
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  methods: {
    // 返回登录表单
    goBackToLogin() {
      this.showSMSVerify = false;
      this.showPhoneRegister = false;
      this.showChangePassword = false;
      this.userInfo = null;
      this.smsPhone = '';
      this.smsAutoSend = false;
      window.sessionStorage.removeItem('token');
    },
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.$ajax({
            url:"coupon-merch/merch/login",
            methods:'POST',
            async:false,
            data:{'lbh':_this.loginForm.lbh,'lpassword':Utils.encrypt(_this.loginForm.lpassword)},
            success:function(response){
              if (response.code==0) {
                let userInfo = response.data;
                // 保存 token
                window.sessionStorage.setItem("token", userInfo.token);
                // 保存用户信息供后续组件使用
                _this.userInfo = userInfo;
                // 根据 useMfa 判断是否需要 MFA 认证
                if (userInfo.useMfa === 'false') {
                  // 不需要MFA认证，检查是否需要强制修改密码
                  if (userInfo.forceChangePwd === '1') {
                    _this.showChangePassword = true;
                  } else {
                    _this.enterMerchantSystem(userInfo);
                  }
                } else {
                  // 需要MFA认证，进入SMS验证流程
                  _this.goToSmsVerify();
                }
              }else{
                _this.$message.error(response.data);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          });
        } else {
          _this.$message.error('请查看输入是否正确!');
          _this.loading=false;
          return false;
        }
      });
    },
    // 登录成功后直接进入SMS短信认证
    // 校验手机号格式：11位数字且以1开头
    isValidPhone(phone) {
      return /^1\d{10}$/.test(phone);
    },
    goToSmsVerify() {
      if (this.userInfo && this.userInfo.lxdh && this.isValidPhone(this.userInfo.lxdh)) {
        // 有正常手机号，直接跳转短信验证码输入界面
        this.smsPhone = this.userInfo.lxdh;
        this.smsAutoSend = true;
        this.showSMSVerify = true;
        this.$nextTick(() => {
          if (this.$refs.smsVerifyRef) {
            this.$refs.smsVerifyRef.focusInput();
          }
        });
      } else {
        // 没有手机号或手机号格式不正确，跳转手机号绑定页面
        this.showPhoneRegister = true;
      }
    },
    // 选择SMS短信认证 - 原逻辑保留，商户直接走goToSmsVerify不再使用
    // selectSMS() {
    //   this.showVerifySelect = false;
    //   if (this.userInfo && this.userInfo.phone) {
    //     this.smsPhone = this.userInfo.phone;
    //     this.smsAutoSend = true;
    //     this.showSMSVerify = true;
    //     this.$nextTick(() => {
    //       if (this.$refs.smsVerifyRef) {
    //         this.$refs.smsVerifyRef.focusInput();
    //       }
    //     });
    //   } else {
    //     this.showPhoneRegister = true;
    //   }
    // },
    // 选择Authenticator OTP认证 - 商户暂不使用，注释保留
    // selectOTP() {
    //   this.showVerifySelect = false;
    //   const _this = this;
    //   _this.$ajax({
    //     url: 'coupon-merch/merch/otp/check',
    //     methods: 'POST',
    //     async: false,
    //     data: { userid: _this.userInfo.id },
    //     token: _this.userInfo.token,
    //     success: function(response) {
    //       if (response.code === 0) {
    //         const data = response.data;
    //         if (data && data.otpType === 1) {
    //           _this.showOtpSetup = true;
    //         } else {
    //           _this.showOTPVerify = true;
    //           _this.$nextTick(() => {
    //             _this.$refs.otpVerifyRef.focusInput();
    //           });
    //         }
    //       } else {
    //         _this.$message.error(response.message || '检查 OTP 状态失败');
    //       }
    //     },
    //     error: function() {
    //       _this.$message.error("请求失败");
    //     }
    //   });
    // },
    // 手机号注册成功后返回登录界面重新登录
    handlePhoneRegisterSuccess(phone) {
      this.showPhoneRegister = false;
      if (this.userInfo) {
        this.userInfo.lxdh = phone;
      }
      const _this = this;
      _this.$alert('手机号绑定成功，请重新登录', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        showClose: false,
        callback: function() {
          // 重置状态，返回登录表单
          _this.userInfo = null;
          _this.smsPhone = '';
          _this.smsAutoSend = false;
          window.sessionStorage.removeItem('token');
        }
      });
    },
    // SMS 验证成功，根据 forceChangePwd 判断进入系统或修改密码
    handleSmsVerifySuccess(smsCode, userInfo) {
      if (this.userInfo && this.userInfo.forceChangePwd === '1') {
        // 新用户，需要修改密码
        this.showSMSVerify = false;
        this.showChangePassword = true;
      } else {
        // 老用户，直接进入系统
        this.enterMerchantSystem(userInfo);
      }
    },
    // 修改密码成功，进入系统
    handleChangePasswordSuccess() {
      this.showChangePassword = false;
      this.enterMerchantSystem(this.userInfo);
    },
    // OTP 相关方法 - 商户暂不使用，注释保留
    // handleOtpVerifySuccess(otpCode, response) {
    //   let userInfo = response.data
    //   this.enterMerchantSystem(userInfo)
    // },
    // handleOtpSetupNext() {
    //   this.showOtpSetup = false;
    //   this.showOTPVerify = true;
    //   this.$nextTick(() => {
    //     this.$refs.otpVerifyRef.focusInput();
    //   });
    // },
    // handleGoToSetup() {
    //   this.showOTPVerify = false;
    //   this.showOtpSetup = true;
    // },
    enterMerchantSystem(userInfo) {
      window.sessionStorage.setItem("id", userInfo.id);
      window.sessionStorage.setItem("userbh", userInfo.merchno);
      window.sessionStorage.setItem("username", userInfo.merchname);
      window.sessionStorage.setItem("token", userInfo.token);
      window.sessionStorage.setItem("utype", "mer");
      this.$store.dispatch('saveMerchInfo', userInfo);
      this.$router.push({path: "/mer_home"});
    }
  },
  created:function(){
    let token = window.sessionStorage.getItem('token');
    let utype = window.sessionStorage.getItem('utype');
    if (token) { // 判断token是否存在
      if (utype === "pt") {
        this.$router.push({path:"/sys_home"});
      }
      if (utype === "mer") {
        this.$router.push({path:"/mer_home"});
      }
    }
  }
};
</script>

<style scoped>
.bg-login{
  background-color: #324057;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.main{
  display: flex;
  justify-content: center;
  /* width: 60%; */
  /* background-color: red; */
}
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.title{
  width: 60%;
  display: flex;
  justify-content: space-between;
}
.title-content{
  color: white;
  margin-right: 50px;
}
.bg-white{
    background-color: #ffffff;
    /* opacity: 0.8; */
}
.middle-box{
  max-width: 400px;
  width: 400px;
  padding-bottom: 10px;
}
.loginscreen .middle-box{
    /* width: 300px; */
}
.login-top{
  background-color: #8B4513;
  height: 6px;
}
.login-title{
	font-weight:bold;
}
.login-header{
	height:265px;
}
.login-logo{
	margin-top:40px;
}
.login-logo-zh,
.login-logo-en{
	font-weight:bold;
	color:#3b3127;
}
.login-logo-zh{
	font-size:45px;
	font-family:"宋体";
}
.login-logo-en{
	font-size:21px;
	font-family:"Helvetica";
}
.middle-box{
  .el-input {
      display: inline-block;
  }
  .el-button {
      display: inline-block;
      width:100%;
  }
  .el-input__inner {
      text-align: center;
  }
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  user-select: none;
}
.bt-width{
  width: 100%;
}

/* 验证方式选择 */
.verify-select {
  text-align: center;
  padding: 20px 0;
}
.verify-select-title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 32px 0;
}
.verify-select-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.verify-option-btn {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 16px;
  border: 1px solid #DCDFE6;
  border-radius: 8px;
  transition: all 0.3s;
}
.verify-option-btn:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.resetMgL0{
  margin-left: 0 !important;
}
.verify-option-icon {
  font-size: 24px;
}
.verify-option-text {
  font-size: 16px;
  font-weight: 500;
}
.title-back-btn {
  position: absolute;
  right: 0;
  font-size: 14px;
  color: #909399;
  padding: 4px 8px;
  text-align: left;
}
.title-back-btn:hover {
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/merch/login.vue